export const REQUEST_AIRPORT_DATA = "REQUEST_AIRPORT_DATA";
export const RECEIVE_AIRPORT_DATA = "RECEIVE_AIRPORT_DATA";

export const requestAirportData = () => ({
  type: REQUEST_AIRPORT_DATA
});

export const receiveAirportData = payload => ({type: RECEIVE_AIRPORT_DATA, payload: payload});


// WEBPACK FOOTER //
// ./src/actions/airportDataActions.js